.spacer {
  flex-grow: 1;
}
